import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSettings = ({ soundEnabled, onToggleSound }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="pretty-section settings-section">
      <div className="pretty-label" style={{ marginBottom: '0.5rem' }}>{t('language')}</div>
      <select
        value={i18n.language}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="pretty-input"
        style={{ width: '100%', marginBottom: '1rem' }}
      >
        <option value="en">{t('english')}</option>
        <option value="sv">{t('swedish')}</option>
        <option value="fr">{t('french')}</option>
      </select>
      <label className="pretty-label">
        <input
          type="checkbox"
          className="pretty-checkbox"
          checked={soundEnabled}
          onChange={onToggleSound}
        /> {t('sound_effects')}
      </label>
    </div>
  );
};

export default LanguageSettings;
